<template>
  <div class="content">
    <div class="order-info">
      <div class="item">
        <div class="item-title">充值单号</div>
        <div class="item-content">
          <span>{{query.order_no}}</span>
        </div>
      </div>
      <div class="item">
        <div class="item-title">创建时间</div>
        <div class="item-content">
          <span>{{query.create_at}}</span>
        </div>
      </div>
      <div class="item">
        <div class="item-title">充值学时</div>
        <div class="item-content">
          <span>{{query.hours}}小时</span>
        </div>
      </div>
      <div class="item">
        <div class="item-title">学时单价</div>
        <div class="item-content">
          <span>{{query.unit_price}}元/小时</span>
        </div>
      </div>
      <div class="item">
        <div class="item-title">支付金额</div>
        <div class="item-content">
          <span>{{query.amount}}</span>
        </div>
      </div>
    </div>
    <div class="order-pay">
      <div class="button" @click="pay">
        <button class="btn">立即支付</button>
      </div>
    </div>
    <div class="hint-1">温馨提示：请在订单创建时间2小时内及时支付，支付成功后不予退款！</div>
    <div v-if="showDialog" class="dialog-item">
      <dialog-item :value="massage"></dialog-item>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { payUrl, hostUrl } from '../http/env.js'
import _wx from '../../static/js/chelun-wx-1.1.js'
import URL from '../../static/js/url.js'
import { unpaidById, pushStudentOrder, cancelOrder } from '@/http/api'
import { baseUrl, OPENIDNEW } from '../http/env.js'
import dialogItem from './dialog'

export default {
  data () {
    return {
      openid: URL.getQueryString('openid') || '',
      query: sessionStorage.query || JSON.stringify({}),
      showDialog: false,
      public_path: process.env.PUBLICK_PATH,
      paid: false,
      iswx: _wx.isWx
    }
  },
  created () {
    if (!this.openid && this.iswx) {
      let url = `${hostUrl}/agent/pay/`
      // window.location.href = `${baseUrl}/moments/commonGetOpenId?url=${url}`
      window.location.href = `${OPENIDNEW}/xc_v1/Wechat/getOpenId?source=` + encodeURIComponent(url);
    } else {
      this.query = JSON.parse(this.query)
    }
  },
  methods: {
    showDia (massage) {
      this.showDialog = true
      this.massage = massage
      setTimeout(() => {
        this.showDialog = false
        this.massage = ''
      }, 1500)
    },
    pay () {
      console.log(2)
      let channel = _wx.isWx ? 'weixin_mp' : 'alipay'
      let callbackUrl = `${hostUrl}/agent/compaid?order_no=${this.query.order_no}`
      let url = `${payUrl}/api.php?c=order&v=pay2&serial_number=${this.query.serial_number}&channel=${channel}&openid=${this.openid}&callback_url=${callbackUrl}`
      axios.get(url).then(res => {
        console.log(res)
        if (res.data.code !== 1) {
          this.showDia('订单状态错误')
          return
        }
        if (_wx.isWx) {
          _wx.pay(res.data.data.order_param, function () {
            window.location.href = res.data.data.order_param.callback_url
          })
        } else {
          window.location.href = res.data.data.url
        }
      })
    },
  },
  components: {
    'dialog-item': dialogItem
  },
}
</script>

<style lang="scss" scoped>
.content {
  color: #000;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #F4F5FC;
  .order-info {
    padding: 0 .3rem;
    box-sizing: border-box;
    background: #fff;
  }
  .hint-1 {
    font-size: 14px;
    color: red;
    // margin-top: .5rem;
    width: 6.9rem;
    margin: .5rem auto;
  }
  .item {
    border-bottom: 1px solid #eee;
    padding: .3rem 0;
    display: -webkit-flex;
    display: flex;
    align-items: center;
    .item-title {
      font-size: .3rem;
      width: 1.5rem;
      text-align: left;
    }
    .item-content {
      font-size: .26rem;
      flex: 1;
      text-align: right;
      span {
        display: inline-block;
        vertical-align: middle;
        color: rgba(51, 51, 51, 1);
        margin-right: .08rem;
      }
    }
  }
  .order-pay {
    padding: 0 .3rem;
    box-sizing: border-box;
    background: #fff;
    margin-top: .2rem;
  }
  .button {
    margin-top: 1rem;
  }
  .btn {
    display: block;
    margin: auto;
    width: 100%;
    height: .90rem;
    background: linear-gradient(32deg, rgba(235, 96, 50, 1), rgba(235, 74, 56, 1));
    border-radius: .12rem;
    font-size: .34rem;
    font-weight: 600;
    color: #FFFFFF;
    line-height: .90rem;
    text-align: center;
  }
}
.dialog {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 9999;
  .main {
    width: 6rem;
    height: 6.17rem;
    background: rgba(255, 255, 255, 1);
    border-radius: .20rem;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    text-align: center;
    .dialog-img {
      width: 2.98rem;
      height: 1.45rem;
      margin: auto;
      margin-top: 1.06rem;
      margin-bottom: .66rem;
    }
    .hint {
      width: 5rem;
      font-size: .34rem;
      font-weight:600;
      color:rgba(0,0,0,1);
      margin: auto;
      text-align: center;
    }
    .btn {
      width: 5rem;
      height: .90rem;
      background: linear-gradient(32deg,rgba(235,96,50,1),rgba(235,74,56,1));
      border-radius: .12rem;
      font-size: .34rem;
      color: #fff;
      line-height: .9rem;
      font-weight: 500;
      margin-top: .6rem;
      display: inline-block;
      vertical-align: middle;
    }
    .close {
      position: absolute;
      right: .38rem;
      top: .38rem;
      width: .34rem;
      background: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/schoolPay.vue